// @flow
import { connect } from 'react-redux';
import { setPermission } from '../../actions/locationPermission';
import { setFitBounds } from '../../actions/map';

export { default } from './withCurrentLocation';
export const applyPermissionToLocationReduxState = component => {
  const mapStateToProps = ({ locationPermission: { permission } }) => ({
    permission,
  });
  return connect(
    mapStateToProps,
    { setPermission, setFitBounds }
  )(component);
};



// WEBPACK FOOTER //
// ./components/withCurrentLocation/index.js